<template>
  <div class="component">
    <div class="tab_focus" >
      <div class="focus-title">
        <span style="margin: 4px 6px 0 0;"><span class="kdfont kdfont-zhinengbiaoqian"></span></span>
        <div class="title-content">简历关注点</div>
      </div>
      <div class="focus-content-box" v-if=focus>
        <div
            v-for="item in componentData"
            class="focus-content"
        >
          <div class="tag-focus">
            <portrait-labels :labelList=convert(item.prominentName)></portrait-labels>
          </div>
          <div class="tag-content">{{ item.prominentDesc }}</div>
        </div>
      </div>
      <div class="noData" v-if=!focus>暂无数据</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TabFocus",
  props: {
    componentData: [Object, Array]
  },
  watch:{
    componentData:{
      handler(val) {
        this.focus = val != null && val.length > 0 ? true : false
      },
      immediate: true
    },
  },
  data() {
    return {
      focus:false,
    }
  },
  mounted() {
    console.log(this.componentData)
  },
  methods: {
    convert(prominentName) {
      return new Array(prominentName)
    }
  },
}
</script>

<style lang="less">
.tab_focus {
  display: flex;
  flex-direction: column;

  .focus-title {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 16px;

    .title-content {
      font-size: 16px;
      color: #212121;
      font-weight: 600;
    }
  }

  .focus-content-box{
    display: flex;
    flex-direction: column;
    margin-bottom: -12px;
  }

  .focus-content {
    display: flex;
    flex-direction: column;
    justify-items: flex-start;
    margin-bottom: 16px;

    .tag-focus {
      display: flex;
      align-items: center;
      .component_label{
        background: rgba(255,255,255,0.00);
        border: 1px solid #FF991C;
        border-radius: 10px;
        font-size: 12px;
        color: #FF991C;
        letter-spacing: 0;
        line-height: 18px;
        font-weight: 400;
      }
    }

    .tag-content {
      width: auto;
      display: flex;
      align-items: center;
      justify-content: left;
      font-size: 12px;
      color: #666666;
      letter-spacing: 0;
      line-height: 18px;
      font-weight: 400;

    }
  }
}
.noData{
  color: #999;
  padding: 0 0 4px 22px;
}
</style>

